module.exports = __webpack_public_path__ + "img/dcom07.0dabf7e9.png";